import { render, staticRenderFns } from "./NodeDocumentation.vue?vue&type=template&id=5b27d756&scoped=true&"
import script from "./NodeDocumentation.vue?vue&type=script&lang=js&"
export * from "./NodeDocumentation.vue?vue&type=script&lang=js&"
import style0 from "./NodeDocumentation.vue?vue&type=style&index=0&id=5b27d756&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b27d756",
  null
  
)

export default component.exports